import { generateHash, generateMinifiedQuery } from "../../client/Graphql/hash";
import { pageQuery } from "./pageQuery";

export const minifiedPageQuery=generateMinifiedQuery(pageQuery);
export const pageQuerySHA = generateHash(minifiedPageQuery);